import { render, staticRenderFns } from "./message-header.html?vue&type=template&id=606e3d43&scoped=true&"
import script from "./message-header.js?vue&type=script&lang=js&"
export * from "./message-header.js?vue&type=script&lang=js&"
import style0 from "./message-header.scss?vue&type=style&index=0&id=606e3d43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e3d43",
  null
  
)

export default component.exports